<div
  class="switcher-container d-flex position-relative"
  *ngIf="!dashboardLayout()"
>
  <div class="d-flex">
    <ng-container *ngIf="lang === 'en'">
      <label class="langLabel">{{ 'shared.ar' | translate }}</label>
      <nz-select
        *ngIf="!dashboardLayout()"
        nzBorderless
        [nzShowArrow]="false"
        [nzDropdownMatchSelectWidth]="false"
        [nzOpen]="dropdownOpen"
        [(ngModel)]="lang"
        (ngModelChange)="changeLanguage($event)"
        (nzBlur)="onDropdownBlur()"
      >
        <nz-option [nzValue]="'en'" [nzLabel]="'shared.en' | translate">
        </nz-option>
        <nz-option [nzValue]="'ar'" [nzLabel]="'shared.ar' | translate">
        </nz-option>
      </nz-select>
    </ng-container>
    <ng-container *ngIf="lang === 'ar'">
      <label class="langLabel">{{ 'shared.en' | translate }}</label>
      <nz-select
        *ngIf="!dashboardLayout()"
        nzBorderless
        [nzShowArrow]="false"
        [nzDropdownMatchSelectWidth]="false"
        [nzOpen]="dropdownOpen"
        [(ngModel)]="lang"
        (ngModelChange)="changeLanguage($event)"
        (nzBlur)="onDropdownBlur()"
      >
        <nz-option [nzValue]="'en'" [nzLabel]="'shared.en' | translate">
        </nz-option>
        <nz-option [nzValue]="'ar'" [nzLabel]="'shared.ar' | translate">
        </nz-option>
      </nz-select>
    </ng-container>
    <svg-icon name="arrow-down" (click)="onDropdownArrowClick($event)" />
  </div>
</div>
<svg-icon
  *ngIf="dashboardLayout()"
  (click)="changeLanguageByIcon($event)"
  name="localization"
/>
